import React from 'react'
import { ReactComponent as Close } from "../../assets/new-icons/close.svg";
import { ReactComponent as Filtro } from "../../assets/new-icons/filter.svg";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { DateTime } from 'luxon';

function Filter({ setFilterActive, filterActive, setTag, tag, year, setYear, tags }) {
    const items = tags

    const switchName = (r) => {
        switch (r) {
            case 'ricarica':
                return 'Ricariche'
            case 'canone-rai':
                return 'Canone Rai'
            case 'consumi':
                return 'Consumi'
            case 'bonus-sociale':
                return 'Bonus'
            case 'oneri-diversi':
                return 'Oneri diversi'
            case 'incasso-sdd':
                return 'Incassi SDD'
            case 'upsell':
                return 'Upsell'
            case 'commissioni':
                return 'Commissioni'
            case 'ricariche-bonus':
                return 'Ricariche bonus'
            default:
                break;
        }
    }
    const switchColor = (r) => {
        switch (r) {
            case 'ricarica':
                return '#FF7D57'
            case 'canone-rai':
                return '#FFD300'
            case 'consumi':
                return '#19C1FF'
            case 'incasso-sdd':
                return '#697386'
            default:
                return '#4F29A8';
        }
    }
    const handleTagAndFilter = (tag) => {
        setTag(tag)
        setFilterActive(!filterActive)
    }
    return (
        <div className="filter">
            <div className="containerFilter" onClick={() => setFilterActive(!filterActive)}>
                <Filtro />
            </div>
            <div className={`boxFilter ${filterActive}`}>
                <div className="close" onClick={() => setFilterActive(!filterActive)}><Close /></div>
                <div className="filterList">
                    <div className="item" onClick={() => handleTagAndFilter('tutti')}>
                        <div className="check">
                            <span>
                                {tag === 'tutti' ? (
                                    <i></i>
                                ) : null}
                            </span>
                        </div>
                        <div className="badge">
                            <span style={{ backgroundColor: switchColor('tutti') }}></span>
                        </div>
                        <p className="secondary">Tutti</p>
                    </div>
                    {items && items.map((r, i) => (
                        <div key={i} className="item" onClick={() => handleTagAndFilter(r)}>
                            <div className="check">
                                <span>
                                    {tag === r ? (
                                        <i></i>
                                    ) : null}
                                </span>
                            </div>
                            <div className="badge">
                                <span style={{ backgroundColor: switchColor(r) }}></span>
                            </div>
                            <p className="secondary">{switchName(r)}</p>
                        </div>
                    ))}
                </div>
                <div className="year">
                    <ArrowBackIosIcon onClick={() => setYear(DateTime.fromFormat(year, 'y').plus({ year: -1 }).toFormat('y'))} />
                    <p className='main'>{DateTime.fromFormat(year, 'y').toFormat('y')}</p>
                    <ArrowForwardIosIcon onClick={() => year === DateTime.now().toFormat('y') ? null : setYear(DateTime.fromFormat(year, 'y').plus({ year: +1 }).toFormat('y'))} />
                </div>
            </div>
        </div>
    )
}

export default Filter